/**
 * @generated SignedSource<<9490b8c026e24bbcdddae0627dc70051>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RecipientType = "admin" | "user" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment$data = {
  readonly attachCertificates: boolean;
  readonly body: string;
  readonly id: string;
  readonly previewText: string;
  readonly recipientType: RecipientType;
  readonly subject: string;
  readonly " $fragmentType": "EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment";
};
export type EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment$key = {
  readonly " $data"?: EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previewText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recipientType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachCertificates",
      "storageKey": null
    }
  ],
  "type": "EmailRewardConfiguration",
  "abstractKey": null
};

(node as any).hash = "b9a3198e286c2fbbe5c0cca64d898967";

export default node;
